exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-paragraph.is-small{font-size:.875rem;font-weight:400;line-height:1.125rem}[dir=ltr].ba-common-paragraph{text-align:left}[dir=rtl].ba-common-paragraph{text-align:right}.ba-common-paragraph,[dir=ltr] .ba-common-paragraph{text-align:left}[dir=rtl] .ba-common-paragraph{text-align:right}.ba-common-paragraph.is-clickable{cursor:pointer}.ba-common-paragraph{margin:16px 0;color:#343334;font-size:1rem}.ba-common-paragraph.is-bold{font-weight:600}.ba-common-paragraph.is-primary{color:#1f57a4;color:hsla(var(--primary1-h,214.73684),var(--primary1-s,68.20513%),var(--primary1-l,38.23529%),1)}", ""]);

// exports
exports.locals = {
	"paragraphClassName": "\"ba-common-paragraph\""
};